import { dataTransformationApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { ProductInfoResponse } from 'src/types';

export const getProductInfo = (config: AxiosRequestConfig = {}) =>
  dataTransformationApi.get<ProductInfoResponse>('/api/v1/productInfo', config);

export const updateProductDescription = (description: string) =>
  dataTransformationApi.patch<void>('/api/v1/productInfo', { description });
